import React from 'react';
import List from '.';
const Products = () => {
  return <List>Products/Services Approvals</List>;
};

export default Products;
